import { useResource } from '@thesisedu/feature-react'

import { ReportDimensionResource } from '../types'

export function useDimensionsAtLevel(level: number): ReportDimensionResource<object, object>[] {
  const dimensions = useResource<ReportDimensionResource<object, object>>('ReportDimension')
  return dimensions.filter(dim => dim.supportedIndices.includes(level))
}
